import { createSelector, createSlice } from '@reduxjs/toolkit';
import store from '../Features/App/store';
import { dcpcApi } from './api/dcpcApi';

const authBroadcastChannel = new BroadcastChannel('auth');
const AUTH_LOGIN = 'AUTH_LOGIN';
const AUTH_LOGOUT = 'AUTH_LOGOUT';

export const loginApi = dcpcApi.injectEndpoints({

  endpoints: (builder) => ({

    login: builder.mutation({
      query: (body) => ({
        url: 'auth/login',
        method: 'POST',
        headers: {
          Authorization: `Basic ${btoa(
            `${body.username}:${body.password}`,
          )}`,
        },
      }),
      async onQueryStarted(_, { queryFulfilled }) {
        try {
          const { data } = await queryFulfilled;
          // console.log('login.onQueryStarted', data);
          window.localStorage.setItem('login', JSON.stringify(data));
          authBroadcastChannel.postMessage({ type: AUTH_LOGIN, payload: data });
        } catch (error) {
          console.log(error);
        }
      },
    }),

    logout: builder.mutation({
      queryFn: () => ({ data: true }),
      onQueryStarted() {
        // console.log('logout.onQueryStarted');
        window.localStorage.removeItem('login');
        authBroadcastChannel.postMessage({ type: AUTH_LOGOUT });
        store.dispatch(dcpcApi.util.resetApiState());
      },
    }),

    loginSilent: builder.mutation({
      queryFn: (data) => ({ data }),
    }),

    logoutSilent: builder.mutation({
      queryFn: (data) => ({ data }),
      async onQueryStarted() {
        store.dispatch(dcpcApi.util.resetApiState());
      },
    }),

  }),
});

export const { useLoginMutation, useLogoutMutation } = loginApi;

export const initiateLogout = () => loginApi.endpoints.logout.initiate();

const initialState = {
  isLoading: false,
  currentUser: null,
  acl: null,
};

const getLoginInitialState = () => {
  const storageAuthState = window.localStorage.getItem('login');
  return storageAuthState ? JSON.parse(storageAuthState) : initialState;
};

const build = (builder) => {
  builder
    .addMatcher(dcpcApi.endpoints.login.matchFulfilled, (state, action) => {
      Object.assign(state, { ...action.payload });
    })
    .addMatcher(dcpcApi.endpoints.logout.matchFulfilled, (state) => {
      Object.assign(state, { ...initialState });
    })
    .addMatcher(
      dcpcApi.endpoints.loginSilent.matchFulfilled,
      (state, action) => {
        Object.assign(state, { ...action.payload });
      },
    )
    .addMatcher(
      dcpcApi.endpoints.logoutSilent.matchFulfilled,
      (state) => {
        Object.assign(state, { ...initialState });
      },
    );
};

// TODO: перенести в папку LOGIN
export const AUTH_SLICE = 'login';
const loginSlice = createSlice({
  name: AUTH_SLICE,
  initialState: getLoginInitialState(),
  extraReducers: build,
  reducers: {
    updateCurrentUser: (state, action) => {
      Object.assign(state, { ...state, currentUser: { ...action.payload } });
    },
  },
});

export const loginReducer = loginSlice.reducer;
export const { updateCurrentUser } = loginSlice.actions;

// Подпишемся на события из других табов
authBroadcastChannel.onmessage = (ev) => {
  switch (ev.data.type) {
    case AUTH_LOGIN:
      // Другие табы сказали Войти
      store.dispatch(dcpcApi.endpoints.loginSilent.initiate(ev.data.payload));
      break;
    case AUTH_LOGOUT:
      // Другие табы сказали Выйти
      store.dispatch(dcpcApi.endpoints.logoutSilent.initiate());
      break;
    default:
      break;
  }
};

export const isAuthSelector = (state) => !!state.login?.currentUser; // авторизация происходит, если была получена информация о пользователе
export const userInfoSelector = (state) => state.login;
export const isLocalAdminSelector = createSelector(
  userInfoSelector,
  (uis) => {
    const {
      acl: {
        regions,
      },
    } = uis;
    return !!Object.keys(regions).find((regionKey) => regions[regionKey].includes('A'));
  },
);
export const isAdminSelector = createSelector( // возвращает true или false в зависимости админ пользователь или нет
  userInfoSelector,
  (uis) => {
    const {
      currentUser: {
        roles,
      },
    } = uis;
    return roles?.includes('RS_ADMIN');
  },
);
export const filterRegionsSelector = createSelector(
  userInfoSelector,
  (uis) => {
    const {
      acl: {
        regions,
      },
    } = uis;
    return Object.keys(regions || {});
  },
);
export const canCreateStationSelector = createSelector(
  userInfoSelector,
  (uis) => {
    const {
      acl: {
        regions,
      },
      currentUser: {
        roles,
      },
    } = uis;
    return roles?.includes('RS_ADMIN') || !!Object.keys(regions).find((regionKey) => regions[regionKey].includes('A'));
  },
);

export const getPermissionStation = createSelector(
  userInfoSelector,
  (_, sid) => sid,
  (uis, sid) => {
    const {
      acl: {
        stations,
      },
    } = uis;
    return stations[sid];
  },
);

export const getPermissionRegion = createSelector(
  userInfoSelector,
  (_, rid) => rid,
  (uis, rid) => {
    const {
      acl: {
        regions,
      },
    } = uis;
    return regions[rid];
  },
);
